import { render, staticRenderFns } from "./AssignColor.vue?vue&type=template&id=8adef21c&scoped=true"
import script from "./AssignColor.vue?vue&type=script&lang=js"
export * from "./AssignColor.vue?vue&type=script&lang=js"
import style0 from "./AssignColor.vue?vue&type=style&index=0&id=8adef21c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adef21c",
  null
  
)

export default component.exports